import { IKontodelDef } from '../../../../../_Common/Components/KonteringManager/Query/KonteringManagerQuery';
import { ModelContext } from '../../../../../../../Model/ModelContext/ModelContext';
import {
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All,
  FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All,
} from '../../Queries/_QueryTypes/FakturaDelQuery';
import KonteringContext, {
  IAttestKodbehorighetUrval,
} from '../../../../../_Common/Components/KonteringManager/KonteringContext';
import React, {
  useContext,
  useCallback,
  useState,
  useMemo,
  type JSX,
} from 'react';
import BusinessDataForm, {
  BusinessDataFormContext,
} from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/BusinessDataForm';
import {
  getAllKontodelarBen,
  getAllKontodelar,
  konteringSaknas,
  getStatusIcon,
  getBeloppErrors,
  getCertiferValidation,
  createTemplateWholeBookKodbeh,
  roundNumberToDecimals,
  getIngaendeMoms,
  getUtlandskMoms,
  getUtlandskAvdrag,
  getUtlandskKostnad,
  getPeriodiseraDisabledReason,
} from './Utils/KonteringUtils';
import {
  getAttributeInfo,
  getCollectionInfo,
} from '../../../../../../../Model/avenyModelUtils';
import {
  IFieldValidation,
  IFieldValidations,
} from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import KonteringLabel from './KonteringLabel';
import { EDControlledExpansionPanel as Accordion } from '../../../../../../../BaseComponents/Accordion/EDExpansionPanel';
import {
  TEDEKAutomatkonteringarTypEnum,
  TEDLRFakturaAttestAttestTypEnum,
  TEDLRFakturaAttestSTATUSEnum,
  TEDLRFakturaDelAttestMinaStatusEnum,
  TEDLRKonteringsForslagFI_REGISTRERASEnum,
  TEDLRLeverantorfakturaMOMSHANTERINGEnum,
} from '../../../../../../../globalQueryTypes';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import mergeSort from '../../../../../../../Utils/mergeSort';
import {
  EDAutoCompleteEdit,
  ISuggestion,
} from '../../../../../../../BaseComponents/AutoCompleteEdit/EDAutoCompleteEdit';
import FakturaDelContext from '../FakturaDelContextManager/FakturaDelContext';
import EditableAttribute from '../../../../../../../Components/Attributes/EditableAttribute/EditableAttribute';
import FakturaAttestKonteringHistoryModal from '../FakturaAttestKonteringHistoryModal/FakturaAttestKonteringHistoryModal';
import { EDInputGroup } from '../../../../../../../BaseComponents/InputGroup/EDInputGroup';
import EDTabs from '../../../../../../../BaseComponents/Tabs/EDTabs';
import EDTab from '../../../../../../../BaseComponents/Tabs/Tab/EDTab';
import Tillaggsinfo from './Components/Tillaggsinfo/Tillaggsinfo';
import {
  isForbrukningsInventarie,
  tillaggsinfoIsKomponent,
} from './Components/Tillaggsinfo/Utils/TillaggsinfoUtils';
import {
  getKonteringRadtyp,
  isAutomaticallyAdded,
  isNumberWithinMarginOfError,
  sortFakturattestByAttestant,
} from '../../Utils/FakturadelUtils';
import { FakturaattestWrapperContext } from '../../../../Rutiner/FakturaDel/Contexts/FakturaattestWrapperContext';
import { LoginStateContext } from '../../../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import RadioButtonsFI from './Components/Tillaggsinfo/Components/RadioButtonsFI/RadioButtonsFI';
import EDTypography from '../../../../../../../BaseComponents/Typography/EDTypography';
import { uniq } from 'ramda';
import { IFilteredKodbehForKonteringsForslag } from '../../../../../_Common/Components/KonteringManager/KonteringManagerUtils';
import { LRSysOptionsQuery_db_SYSOptions_All } from '../../Queries/LRSysOptionQuery/_QueryTypes/LRSysOptionsQuery';
import EDBox from '../../../../../../../BaseComponents/EDBox/EDBox';
import { getAttributeSafe } from '../../../../../../../Components/Urval/Utils/urvalUtils';
import clientAvenyModel from '../../../../../../../Model/clientAvenyModel';
import { IClientBusinessModel } from '../../../../../../../Types/ClientModelTypes';
import { findFormatter } from '../../../../../../../Utils/Formatters/FindFormatter';
import { FakturaDelType__Associations_Faktura__Associations_Konteringsforslag_All__Associations } from '../../Queries/_QueryTypes/FakturaDelType';
import { ObjektLank } from '../../../../../_Common/Components/BusinessCollectionComponents/ObjektLank/ObjektLank';
import { useIsBreakpointOrLarger } from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';
import { IValues } from '../../../../../_StandardRutin/Mutations/ObjectMutations/ObjectUpdateMutationBase';
import { lastDayInMonth } from '../../../../../../../Utils/dateUtils';
import { FormUpdateAssociatonType } from '../../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { MOMSSATS_TOLERANS_DEFAULT_VALUE } from '../../Consts/FakturadelConsts';
import DisplayText from '../../../../../../../Components/Attributes/DisplayText/DisplayText';
import EDCaptionedValue from '../../../../../../../BaseComponents/CaptionedValue/EDCaptionedValue';
import { LR_MOMSHANTERING_LEVFAKT_MOMSATSTOLERANS } from '../../Consts/FakturaDelSysoptionConsts';
import FunctionMenu from '../../../../../_Common/Components/FunctionMenu/FunctionMenu/FunctionMenu';
import FunctionItem from '../../../../../_Common/Components/FunctionMenu/FunctionItem/FunctionItem';
import FakturaattestImportDialog from '../FakturaattestImportDialog/FakturaattestImportDialog';
import { useIsTouchDevice } from '../../../../../../../Components/BreakpointContext/BreakpointContextUtils';

export const KONTERING_COLLECTION_NAME = 'LRKonteringsForslag';
export const FAKTURADEL_COLLECTION_NAME = 'LRFakturaDel';

export const BELOPP_FIELD_NAME = 'belopp';

const SELECTABLE_BESLUTSATTEST_STATUS = [TEDLRFakturaAttestSTATUSEnum.UTDELAD];

const konteringsForslagsModel: IClientBusinessModel =
  clientAvenyModel.LR.BusinessModels.LRKonteringsForslag;

interface IProps {
  autoFocusBelopp?: boolean;
  expanded: boolean;
  id?: string;
  isFIActive: boolean;
  isNew?: boolean;
  konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null;
  konteringsForslagIndex: number;
  minFakturaAttest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All | null;
  setExpanded: (
    event: React.SyntheticEvent<Element, Event>,
    newValue: boolean
  ) => void;
  setNewBeloppChange: React.Dispatch<React.SetStateAction<string | null>>;
  virtual?: boolean;
  avdragsRatt: number;
}

interface IMenuItem {
  id: string;
  disabled?: boolean;
  disabledReason?: React.ReactNode;
  icon: any;
  text: string;
  testId?: string;
  onClick: () => void;
}

interface INewKontodelValue {
  name: string;
  value: string;
  id: string;
}

const useStyles = makeStyles()((theme: Theme) => ({
  deleteButtonContainer: {
    width: '100%',
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  sameRowFlex: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    [theme.breakpoints.down('md')]: {
      alignItems: 'flex-start',
      flexFlow: 'column nowrap',
    },
  },
  beloppFlex: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: '100px',
    paddingRight: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      flexBasis: 'auto',
      flexGrow: 1,
      paddingRight: theme.spacing(1),
      width: '100%',
    },
  },
  attestantFlex: {
    flexGrow: 4,
    flexShrink: 1,
    flexBasis: '100px',
    [theme.breakpoints.down('md')]: {
      flexBasis: 'auto',
      flexGrow: 1,
      paddingRight: theme.spacing(1),
      width: '100%',
    },
  },

  expandableInnerContainer: {
    width: '100%',
    '& [class*="MuiAccordion-root"]': {
      '&[class*="MuiAccordion-rounded"]': {
        '&[class*="MuiPaper-rounded"]': {
          '&[class*="Mui-expanded"]': {
            boxShadow: 'none',
            '&:first-of-type': {
              marginTop: 0,
            },
            '&:last-child': {
              marginBottom: 0,
            },
            '& [class*="MuiAccordionSummary-root"], & [class*="MuiAccordionDetails-root"]':
              {
                backgroundColor: 'transparent',
              },
          },
        },
      },
    },
  },
  expansionPanelRoot: {
    backgroundColor: 'transparent',
  },
  content: {
    backgroundColor: theme.palette.background.paper,
  },
  summaryContent: {
    width: `calc(100% - ${theme.spacing(9.5)})`,
  },
  functionMenu: {
    display: 'none',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 1,
    height: '100%',
    [theme.breakpoints.up('md')]: {
      right: theme.spacing(1),
    },
  },
  showFunctionMenu: {
    display: 'flex',
  },
  iconWrapper: {
    marginRight: theme.spacing(1.5),
    [theme.breakpoints.up('md')]: {
      marginRight: theme.spacing(3.5),
    },
  },
  summaryRoot: {
    '&:hover': {
      background: theme.customProperties.Fade.BlueGray.hover,
    },
  },

  tabs: {
    width: '100%',
  },
}));

const currencyFormatter = findFormatter('TEDFormatCurr');

const noSvenskMomsValue = {
  id: 'im',
  value: 'Ingen moms',
  name: 'Ingen moms',
  data: {
    ING_MOMS_MALL: null,
    ING_MOMS_SATS: null,
    ING_MOMS_BELOPP: null,
    MOMS_SATS1: null,
    MOMS_SATS2: null,
    DATUMMOMSBYTE: null,
  },
};

const KonteringForslagComp: React.FC<
  React.PropsWithChildren<IProps>
> = props => {
  const { avenyCollectionMap } = useContext(ModelContext);
  const fakturaattestContext = useContext(FakturaattestWrapperContext);
  const fakturaDelContext = useContext(FakturaDelContext);
  const {
    setBelopp,
    setKontodel,
    beslutsattestByKonteringsforslag,
    bokfDatum,
    isBeslutsattestantChanged: contextIsBeslutsattestantChanged,
    isBeloppChanged: contextIsBeloppChanged,
    setBeloppExklMoms,
    getBeloppInklMomsFormValue,
    getKostnadsBeloppFormValue,
  } = fakturaDelContext;

  const { setExpanded } = props;
  const formContext = useContext(BusinessDataFormContext);
  const formContextUpdate = formContext?.update;
  const konteringContext = useContext(KonteringContext);
  const loginStateContext = useContext(LoginStateContext);

  const { classes, cx } = useStyles();
  const isMediumOrLarger = useIsBreakpointOrLarger('md');
  const isTouch = useIsTouchDevice();

  const [hovered, setHovered] = useState(false);
  const [selectedOption, setSelectedOption] = useState<boolean>(false);
  const [importDialogOpen, setImportDialogOpen] = useState<boolean>(false);
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);

  const fakturaDelCollection = getCollectionInfo(
    FAKTURADEL_COLLECTION_NAME,
    null,
    avenyCollectionMap
  );

  const antalAttribute = useMemo(
    () => getAttributeSafe('LRKonteringsForslag', 'ANTAL', avenyCollectionMap),
    [avenyCollectionMap]
  );

  const requireMotKodbeh: boolean = useMemo(() => {
    return (
      fakturaattestContext.sysOptions?.filter(
        (option: LRSysOptionsQuery_db_SYSOptions_All) =>
          option.OptionKey === 'LR_REQUIRE_MOTKODBEH'
      )?.[0]?.OptionData === 'Y'
    );
  }, [fakturaattestContext.sysOptions]);

  const sysMomsTolerans = useMemo(() => {
    return fakturaattestContext.sysOptions?.find(
      sysopt => sysopt.OptionKey === LR_MOMSHANTERING_LEVFAKT_MOMSATSTOLERANS
    );
  }, [fakturaattestContext.sysOptions]);

  const periodiseringBeloppEnhet: number = useMemo(() => {
    return fakturaattestContext.sysPrisbasbelopp?.find(sysbasbelopp => {
      const sysbasbeloppDate = new Date(sysbasbelopp.BOKF_AR);
      return sysbasbeloppDate.getFullYear() === bokfDatum.getFullYear();
    })?.BeloppEnhet;
  }, [bokfDatum, fakturaattestContext.sysPrisbasbelopp]);

  const isFakturaBeloppLowerThanPeriodiseringBeloppEnhet = useMemo(() => {
    return (
      formContext?.formState.currentValues.FakturaBelopp2 <
      periodiseringBeloppEnhet
    );
  }, [
    formContext?.formState.currentValues.FakturaBelopp2,
    periodiseringBeloppEnhet,
  ]);

  const belopp =
    (props.konteringsforslag?.DEBET ?? 0) -
    (props.konteringsforslag?.KREDIT ?? 0);

  const konteringsForslagWithKodbeh:
    | IFilteredKodbehForKonteringsForslag
    | undefined = konteringContext.konteringUtils
    .getKonteringsForslagWithKodbeh()
    .find(changedKf => {
      return changedKf.konteringsforslagID === props.konteringsforslag?.id;
    });

  const attestKodbehorigheter: IAttestKodbehorighetUrval[] | undefined =
    useMemo(() => {
      const kodbeh =
        fakturaDelContext.minFakturaAttest.aktuellFakturaAttest?.AttestTyp ===
          TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST && !requireMotKodbeh
          ? createTemplateWholeBookKodbeh(
              fakturaDelContext.minFakturaAttest,
              fakturaDelContext.kodplanId
            )
          : konteringsForslagWithKodbeh?.attestkodbehorigheter;

      if (kodbeh === undefined || kodbeh.length === 0) {
        return konteringsForslagWithKodbeh?.correctnessKodbeh;
      }
      return kodbeh;
    }, [
      fakturaDelContext.kodplanId,
      fakturaDelContext.minFakturaAttest,
      konteringsForslagWithKodbeh?.attestkodbehorigheter,
      konteringsForslagWithKodbeh?.correctnessKodbeh,
      requireMotKodbeh,
    ]);

  const kontodelsDef = useMemo(
    () =>
      konteringContext.konteringUtils.getActiveAttestKontodelDefsByKodplanId(
        fakturaDelContext.kodplanId,
        fakturaDelContext.bokfDatum,
        attestKodbehorigheter,
        formContext?.formState.currentValues?._Associations?.Faktura
          ?.IngaendeMomsBaskonto,
        fakturaDelContext.isKobFaktura
      ),
    [
      attestKodbehorigheter,
      fakturaDelContext.bokfDatum,
      fakturaDelContext.isKobFaktura,
      fakturaDelContext.kodplanId,
      formContext?.formState.currentValues?._Associations?.Faktura
        ?.IngaendeMomsBaskonto,
      konteringContext.konteringUtils,
    ]
  );

  const kontodelsDefOrdingsNrWithMoms = useMemo(() => {
    return konteringContext.konteringUtils.getMomsForKontodelsDefOrdningsnr(
      fakturaDelContext.kodplanId
    );
  }, [fakturaDelContext.kodplanId, konteringContext.konteringUtils]);

  const attestTyp: TEDLRFakturaAttestAttestTypEnum =
    fakturaDelContext.minFakturaAttest.aktuellFakturaAttest?.AttestTyp ===
    TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
      ? formContext?.data?.AttestMinaStatus ===
        TEDLRFakturaDelAttestMinaStatusEnum.KONTROLLATTESTERAS
        ? TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST
        : TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST
      : TEDLRFakturaAttestAttestTypEnum.MOTTAGNINGSATTEST;

  const kodstrangBenamningar = getAllKontodelarBen(
    props.konteringsforslag?._Associations
  );
  const kodstrangDelar = useMemo(
    () => getAllKontodelar(props.konteringsforslag?._Associations),
    [props.konteringsforslag?._Associations]
  );

  const kodstrang = kodstrangDelar.map(kd => kd?.KONTODEL ?? '').join('-');

  const { attribute: beloppAttribute } = getAttributeInfo(
    'LRFakturaDel',
    'FakturaBelopp2',
    avenyCollectionMap
  );
  const { attribute: perFromDateAttribute } = getAttributeInfo(
    'LRKonteringsForslag',
    'PER_FROM_DATUM',
    avenyCollectionMap
  );
  const { attribute: perToDateAttribute } = getAttributeInfo(
    'LRKonteringsForslag',
    'PER_FROM_DATUM',
    avenyCollectionMap
  );

  const isFieldError = useCallback(
    (arg: IFieldValidation | string): arg is IFieldValidation =>
      typeof arg === 'object',
    []
  );

  const beslutsAttestant = useMemo(
    () => beslutsattestByKonteringsforslag(props.konteringsforslag),
    [beslutsattestByKonteringsforslag, props.konteringsforslag]
  );

  const beslutsAttesterad =
    beslutsAttestant?.STATUS === TEDLRFakturaAttestSTATUSEnum.ATTESTERAD;

  const disabled =
    attestTyp === TEDLRFakturaAttestAttestTypEnum.KONTROLLATTEST ||
    beslutsAttesterad ||
    !fakturaDelContext.jagAttesterar;

  const radtyp = useMemo(() => {
    return props.konteringsforslag?.RADTYP;
  }, [props.konteringsforslag?.RADTYP]);

  const isForKontodel = (
    v: IFieldValidation,
    kontodel: IKontodelDef
  ): boolean =>
    v.fieldName ===
    props.konteringsforslag?.id + ' ' + kontodel.ordningsNr.toString();

  const saknarKontering = useMemo(
    () => konteringSaknas(props.konteringsforslag?._Associations),
    [props.konteringsforslag?._Associations]
  );

  const onPeriodClick = useCallback(() => {
    const updateValues = props.konteringsforslag?.PERIODISERAD
      ? {
          PERIODISERAD: false,
          PER_FROM_DATUM: null,
          PER_TOM_DATUM: null,
        }
      : {
          PERIODISERAD: true,
        };

    formContextUpdate?.([
      'Faktura',
      {
        associationName: 'Konteringsforslag',
        operation: props.isNew ?? false ? 'Add_Values' : 'Update_Values',
        id: props.konteringsforslag?.id ?? '',
        values: updateValues,
      },
    ]);
    if (
      props.expanded === false &&
      (props.konteringsforslag?.PERIODISERAD === false ||
        props.konteringsforslag?.PERIODISERAD == undefined)
    ) {
      setExpanded({} as never, true);
    }
  }, [
    props.konteringsforslag?.PERIODISERAD,
    props.konteringsforslag?.id,
    props.isNew,
    props.expanded,
    formContextUpdate,
    setExpanded,
  ]);

  const onBeloppChange = useCallback(
    (
        konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null,
        isNew?: boolean
      ) =>
      (newValue: any, validationErrorMessage?: IFieldValidations) => {
        if (konteringsforslag) {
          setBelopp(
            konteringsforslag.id,
            newValue,
            Boolean(isNew),
            saknarKontering,
            props.setNewBeloppChange,
            validationErrorMessage
          );
        }
      },
    [setBelopp, saknarKontering, props.setNewBeloppChange]
  );

  const onBeloppExklMomsChange = useCallback(
    (
        konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null,
        isNew?: boolean
      ) =>
      (newValue: any) => {
        if (konteringsforslag) {
          let values: IValues = {};
          setBeloppExklMoms(
            konteringsforslag.id,
            newValue,
            Boolean(isNew),
            props.setNewBeloppChange
          );

          const utlandskMoms = getUtlandskMoms(
            newValue,
            props.konteringsforslag?.UTL_MOMS_SATS
          );

          const updatedKostandsBeloppValue = getKostnadsBeloppFormValue(
            props.konteringsforslag?.id ?? '',
            props.konteringsforslag?.DEBET,
            props.konteringsforslag?.KREDIT,
            props.setNewBeloppChange,
            radtyp,
            0,
            newValue,
            0,
            props.avdragsRatt,
            null,
            props.konteringsforslag?.UTL_MOMS_SATS,
            utlandskMoms
          );

          if (updatedKostandsBeloppValue) {
            values = { ...values, ...updatedKostandsBeloppValue };
          }

          const utlandskAvdrag = getUtlandskAvdrag(
            newValue,
            props.konteringsforslag?.UTL_MOMS_SATS,
            props.avdragsRatt
          );

          values = {
            ...values,
            UTL_MOMS: utlandskMoms,
            UTL_MOMS_AVDRAG: utlandskAvdrag,
          };

          formContextUpdate?.([
            'Faktura',
            {
              associationName: 'Konteringsforslag',
              operation: isNew ? 'Add_Values' : 'Update_Values',
              id: konteringsforslag.id,
              values: values,
            },
          ]);
        }
      },
    [
      setBeloppExklMoms,
      props.setNewBeloppChange,
      props.konteringsforslag,
      getKostnadsBeloppFormValue,
      radtyp,
      props.avdragsRatt,
      formContextUpdate,
    ]
  );

  const onBeloppInklMomsChange = useCallback(
    (
        konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null,
        isNew?: boolean
      ) =>
      (newValue: any, validationErrorMessage?: IFieldValidations) => {
        if (konteringsforslag) {
          let values: IValues = {};
          const beloppInklMomsValue = getBeloppInklMomsFormValue(
            konteringsforslag.id,
            newValue,
            props.setNewBeloppChange
          );
          if (beloppInklMomsValue) {
            values = { ...values, ...beloppInklMomsValue };
          }

          const updatedKostandsBeloppValue = getKostnadsBeloppFormValue(
            props.konteringsforslag?.id ?? '',
            props.konteringsforslag?.DEBET,
            props.konteringsforslag?.KREDIT,
            props.setNewBeloppChange,
            radtyp,
            newValue,
            0,
            props.konteringsforslag?.ING_MOMS_SATS,
            props.avdragsRatt,
            null,
            props.konteringsforslag?.UTL_MOMS_SATS,
            props.konteringsforslag?.UTL_MOMS
          );

          if (updatedKostandsBeloppValue) {
            values = { ...values, ...updatedKostandsBeloppValue };
          }

          const ingandeMomsBelopp = getIngaendeMoms(
            newValue,
            true,
            props.konteringsforslag?.ING_MOMS_SATS,
            props.avdragsRatt
          );

          values = { ...values, ING_MOMS_BELOPP: ingandeMomsBelopp };

          formContext?.update([
            'Faktura',
            {
              associationName: 'Konteringsforslag',
              operation: isNew ? 'Add_Values' : 'Update_Values',
              id: konteringsforslag.id,
              values: values,
            },
          ]);
        }
      },
    [
      getBeloppInklMomsFormValue,
      props.setNewBeloppChange,
      props.konteringsforslag,
      getKostnadsBeloppFormValue,
      radtyp,
      props.avdragsRatt,
      formContext,
    ]
  );

  const isBeloppChanged = useMemo(() => {
    if (props.konteringsforslag) {
      return contextIsBeloppChanged(props.konteringsforslag);
    } else {
      return false;
    }
  }, [props.konteringsforslag, contextIsBeloppChanged]);

  const onKontodelChange = useCallback(
    (
        konteringsforslag: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Faktura__Associations_Konteringsforslag_All | null,
        kontodelLopnr: number,
        kodplanId: string,
        isFakturaBeloppLowerThanPeriodiseringBeloppEnhet: boolean,
        isNew?: boolean
      ) =>
      (newValue: INewKontodelValue | null) => {
        if (konteringsforslag) {
          setKontodel(
            konteringsforslag.id,
            newValue?.value ?? '',
            kontodelLopnr,
            kodplanId,
            fakturaDelContext.bokfDatum,
            Boolean(isNew),
            props.isFIActive,
            isFakturaBeloppLowerThanPeriodiseringBeloppEnhet
          );

          if (kontodelsDefOrdingsNrWithMoms === kontodelLopnr) {
            let values: IValues = {};
            //TODO: Räkna om momsplikti
            const momspliktig =
              konteringContext.konteringUtils.isNewSelectedKontodelMomspliktig(
                kodplanId,
                kontodelLopnr,
                newValue?.id ?? '',
                fakturaDelContext.bokfDatum
              );

            const momsHantering: TEDLRLeverantorfakturaMOMSHANTERINGEnum | null =
              formContext?.formState.currentValues?._Associations?.Faktura
                ?.MOMSHANTERING;
            const registreratMomsBelopp =
              formContext?.formState.currentValues?._Associations?.Faktura
                ?.MomsBelopp2;

            const newRadtyp = getKonteringRadtyp(
              momsHantering,
              registreratMomsBelopp,
              momspliktig
            );

            const newAvdragsratt =
              konteringContext.konteringUtils.getAvdragsratt(
                kodplanId,
                kontodelLopnr,
                newValue?.id ?? '',
                fakturaDelContext.bokfDatum,
                newRadtyp
              );

            //Uppdatera kostnadsbeloppet när man byter koddel
            let momsSats: number | null | undefined =
              props.konteringsforslag?.ING_MOMS_SATS;
            let refMomsmallUpdateValue: FormUpdateAssociatonType | null = null;
            if (momspliktig) {
              if (
                momsHantering ===
                TEDLRLeverantorfakturaMOMSHANTERINGEnum.SVENSK__ENLIGT_KODDEL
              ) {
                if (props.konteringsforslag?.INGEN_MOMS !== true) {
                  const kalkMomssats =
                    formContext?.formState.currentValues._Associations?.Faktura
                      ?.KalkMomssats ?? 0;

                  //TODO: Kolla på DATUMMOMSBYTE för att se om MOMS_SATS2 behöver användas
                  const preSelectedMomssats =
                    fakturaattestContext.sysMoms?.find(sysmoms =>
                      isNumberWithinMarginOfError(
                        sysmoms.MOMS_SATS1,
                        sysMomsTolerans?.OptionData ??
                          MOMSSATS_TOLERANS_DEFAULT_VALUE,
                        kalkMomssats
                      )
                    );

                  if (
                    preSelectedMomssats &&
                    props.konteringsforslag?.ING_MOMS_SATS == null
                  ) {
                    momsSats =
                      props.konteringsforslag?.ING_MOMS_SATS ??
                      preSelectedMomssats.MOMS_SATS1;
                    refMomsmallUpdateValue = {
                      associationName: 'IngMoms',
                      operation: 'Ref',
                      id: preSelectedMomssats.id ?? '',
                      values: {
                        id: preSelectedMomssats.id ?? '',
                      },
                    };
                    values = { ...values, ING_MOMS_SATS: momsSats };
                  }
                }
              } else if (
                momsHantering ===
                  TEDLRLeverantorfakturaMOMSHANTERINGEnum.UTLANDSK__ENLIGT_KODDEL ||
                momsHantering ===
                  TEDLRLeverantorfakturaMOMSHANTERINGEnum.UTLANDSK__ENLIGT_LEVERANTOR
              ) {
                {
                  const utlMomsavdrag = getUtlandskAvdrag(
                    props.konteringsforslag?.BELOPP_EXKL_MOMS,
                    props.konteringsforslag?.UTL_MOMS_SATS,
                    newAvdragsratt
                  );
                  values = {
                    ...values,
                    UTL_MOMS_AVDRAG: utlMomsavdrag,
                  };

                  momsSats = props.konteringsforslag?.UTL_MOMS_SATS;
                }
              }
            } else {
              momsSats = null;
              //Nollställ fält som inte berörs vald koddel inte är momspliktig.
              values = {
                ...values,
                ING_MOMS_SATS: null,
                ING_MOMS_MALL: null,
                ING_MOMS_BELOPP: null,
                VIKT: null,
                MOMSPLIKTIG: false,
              };

              if (
                momsHantering ===
                TEDLRLeverantorfakturaMOMSHANTERINGEnum.UTLANDSK__ENLIGT_KODDEL
              ) {
                values = { ...values, UTL_MOMS_AVDRAG: null };
              }

              refMomsmallUpdateValue = {
                associationName: 'IngMoms',
                operation: 'Ref',
                values: null,
              };
            }

            //Uppdatera ingående moms
            if (momsSats != null) {
              const ingandeMomsBelopp = getIngaendeMoms(
                props.konteringsforslag?.BELOPP_INKL_MOMS,
                true,
                momsSats,
                newAvdragsratt
              );

              values = {
                ...values,
                ING_MOMS_BELOPP: ingandeMomsBelopp,
              };
            }

            const updatedKostandsBeloppValue = getKostnadsBeloppFormValue(
              props.konteringsforslag?.id ?? '',
              props.konteringsforslag?.DEBET,
              props.konteringsforslag?.KREDIT,
              props.setNewBeloppChange,
              newRadtyp,
              props.konteringsforslag?.BELOPP_INKL_MOMS,
              props.konteringsforslag?.BELOPP_EXKL_MOMS,
              momsSats,
              newAvdragsratt,
              null,
              props.konteringsforslag?.UTL_MOMS_SATS,
              props.konteringsforslag?.UTL_MOMS
            );

            if (updatedKostandsBeloppValue) {
              values = { ...values, ...updatedKostandsBeloppValue };
            }

            if (
              momspliktig &&
              (momsHantering ===
                TEDLRLeverantorfakturaMOMSHANTERINGEnum.SVENSK__ENLIGT_KODDEL ||
                momsHantering ===
                  TEDLRLeverantorfakturaMOMSHANTERINGEnum.UTLANDSK__ENLIGT_KODDEL)
            ) {
              values = {
                ...values,
                VIKT: newAvdragsratt,
                MOMSPLIKTIG: momspliktig,
              };
            }

            values = {
              ...values,
              RADTYP: newRadtyp,
            };

            if (refMomsmallUpdateValue) {
              //Nollställ assoc IngMoms
              formContext?.update([
                'Faktura',
                {
                  associationName: 'Konteringsforslag',
                  operation:
                    props.isNew ?? false ? 'Add_Values' : 'Update_Values',
                  id: props.konteringsforslag?.id ?? '',
                  values: values,
                },
                refMomsmallUpdateValue,
              ]);
            } else {
              formContext?.update([
                'Faktura',
                {
                  associationName: 'Konteringsforslag',
                  operation:
                    props.isNew ?? false ? 'Add_Values' : 'Update_Values',
                  id: props.konteringsforslag?.id ?? '',
                  values: values,
                },
              ]);
            }
          }
        }
      },
    [
      setKontodel,
      fakturaDelContext.bokfDatum,
      props.isFIActive,
      props.konteringsforslag,
      props.setNewBeloppChange,
      props.isNew,
      kontodelsDefOrdingsNrWithMoms,
      konteringContext.konteringUtils,
      formContext,
      getKostnadsBeloppFormValue,
      fakturaattestContext.sysMoms,
      sysMomsTolerans,
    ]
  );

  const isKontodelChanged = useCallback(
    (kontodelLopnr: number) => {
      const kodstrang = kodstrangDelar.find(x => x?.LOPNR === kontodelLopnr);
      if (kodstrang && props.konteringsforslag) {
        return fakturaDelContext.isKontodelChanged(
          props.konteringsforslag,
          kodstrang.id,
          kontodelLopnr
        );
      }

      return false;
    },
    [props.konteringsforslag, fakturaDelContext, kodstrangDelar]
  );

  const onMomsSatsSelected = useCallback(
    (suggestion: ISuggestion<string> | null) => {
      //TODO: Kolla på DATUMMOMSBYTE för att se om MOMS_SATS2 behöver användas
      let values: IValues = {};

      const ingandeMomsBelopp = getIngaendeMoms(
        props.konteringsforslag?.BELOPP_INKL_MOMS,
        true,
        suggestion?.data?.MOMS_SATS1,
        props.avdragsRatt
      );
      values = {
        ...values,
        ING_MOMS_SATS: suggestion?.data?.MOMS_SATS1 ?? null,
        ING_MOMS_BELOPP: ingandeMomsBelopp,
        INGEN_MOMS: suggestion?.name === 'Ingen moms' ? true : null,
      };

      const newKostnadsBeloppValue = getKostnadsBeloppFormValue(
        props.konteringsforslag?.id ?? '',
        props.konteringsforslag?.DEBET,
        props.konteringsforslag?.KREDIT,
        props.setNewBeloppChange,
        radtyp,
        props.konteringsforslag?.BELOPP_INKL_MOMS,
        0,
        suggestion?.data?.MOMS_SATS1,
        props.avdragsRatt,
        null,
        props.konteringsforslag?.UTL_MOMS_SATS,
        props.konteringsforslag?.UTL_MOMS
      );

      if (newKostnadsBeloppValue) {
        values = { ...values, ...newKostnadsBeloppValue };
      }

      if (suggestion?.name === 'Ingen moms') {
        formContext?.update([
          'Faktura',
          {
            associationName: 'Konteringsforslag',
            operation: props.isNew ?? false ? 'Add_Values' : 'Update_Values',
            id: props.konteringsforslag?.id ?? '',
            values: values,
          },
          {
            associationName: 'IngMoms',
            operation: 'Ref',
            values: null,
          },
        ]);
      } else {
        formContext?.update([
          'Faktura',
          {
            associationName: 'Konteringsforslag',
            operation: props.isNew ?? false ? 'Add_Values' : 'Update_Values',
            id: props.konteringsforslag?.id ?? '',
            values: values,
          },
        ]);
      }
    },
    [
      props.avdragsRatt,
      formContext,
      props.isNew,
      props.konteringsforslag,
      props.setNewBeloppChange,
      radtyp,
      getKostnadsBeloppFormValue,
    ]
  );

  const onUtlandsMomsSelected = useCallback(
    (suggestion: ISuggestion<string> | null) => {
      let values: IValues = {};

      const utlandskMoms = getUtlandskMoms(
        props.konteringsforslag?.BELOPP_EXKL_MOMS,
        suggestion?.data?.UTL_MOMS_SATS
      );

      const utlandskAvdrag = getUtlandskAvdrag(
        props.konteringsforslag?.BELOPP_EXKL_MOMS,
        suggestion?.data?.UTL_MOMS_SATS,
        props.avdragsRatt
      );

      values = {
        ...values,
        UTL_MOMS_SATS: suggestion?.data?.UTL_MOMS_SATS,
        UTL_MOMS: utlandskMoms,
        UTL_MOMS_AVDRAG: utlandskAvdrag,
      };

      if (!props.isNew) {
        values = { ...values, _version: props.konteringsforslag?._version };
      }

      const newKostnadsBeloppValue = getKostnadsBeloppFormValue(
        props.konteringsforslag?.id,
        props.konteringsforslag?.DEBET,
        props.konteringsforslag?.KREDIT,
        props.setNewBeloppChange,
        radtyp,
        0,
        props.konteringsforslag?.BELOPP_EXKL_MOMS,
        suggestion?.data?.MOMS_SATS1,
        props.avdragsRatt,
        null,
        suggestion?.data?.UTL_MOMS_SATS,
        utlandskMoms
      );

      if (newKostnadsBeloppValue) {
        values = { ...values, ...newKostnadsBeloppValue };
      }

      formContext?.update([
        'Faktura',
        {
          associationName: 'Konteringsforslag',
          operation: props.isNew ?? false ? 'Add_Values' : 'Update_Values',
          id: props.konteringsforslag?.id ?? '',
          values: values,
        },
      ]);
    },
    [
      props.avdragsRatt,
      formContext,
      getKostnadsBeloppFormValue,
      props.isNew,
      props.konteringsforslag,
      props.setNewBeloppChange,
      radtyp,
    ]
  );

  const filterUtlandsMomsMall = (
    defaultValues: ISuggestion<string>[]
  ): ISuggestion<string>[] => {
    return defaultValues.filter(suggestion => {
      return (
        suggestion.data._typ ===
          TEDEKAutomatkonteringarTypEnum.UTLANDSKMOMSAUTOMATKONTERING &&
        suggestion.data.AKTIV === 'JA'
      );
    });
  };

  const onDeleteClick = useCallback(() => {
    fakturaDelContext.deleteKonteringsforslag(
      null,
      props.konteringsforslag?.id ?? '',
      props.setNewBeloppChange
    );
  }, [fakturaDelContext, props.konteringsforslag, props.setNewBeloppChange]);

  const onBeslutsattestantChanged = (
    fakturaattest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All | null
  ) => {
    if (props.konteringsforslag) {
      fakturaDelContext.setBeslutsattestant(
        props.konteringsforslag,
        fakturaattest,
        isAutomaticallyAdded(props.konteringsforslag)
      );
    }
  };

  const onAntalChange = (newValue: string | null) => {
    if (newValue === null) {
      formContext?.update([
        'Faktura',
        {
          associationName: 'Konteringsforslag',
          operation: props.isNew ?? false ? 'Add_Values' : 'Update_Values',
          id: props.konteringsforslag?.id ?? '',
          values: {
            ANTAL: null,
          },
        },
      ]);
    } else {
      let value = parseFloat(newValue);

      if (Number.isNaN(value)) {
        value = 0;
      }

      value = roundNumberToDecimals(
        Math.abs(value),
        antalsredovisning?.unit?.ANTALDEC ?? 2
      );

      formContext?.update([
        'Faktura',
        {
          associationName: 'Konteringsforslag',
          operation: props.isNew ?? false ? 'Add_Values' : 'Update_Values',
          id: props.konteringsforslag?.id ?? '',
          values: {
            ANTAL: value,
          },
        },
      ]);
    }
  };

  const isBeslutsattestantChanged = useMemo(() => {
    if (props.konteringsforslag) {
      return contextIsBeslutsattestantChanged(props.konteringsforslag);
    } else {
      return false;
    }
  }, [props.konteringsforslag, contextIsBeslutsattestantChanged]);

  const filterSelectableBeslutsattester = (
    fakturaAttest: FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All
  ): boolean => {
    return (
      fakturaAttest.AttestTyp ===
        TEDLRFakturaAttestAttestTypEnum.BESLUTSATTEST &&
      SELECTABLE_BESLUTSATTEST_STATUS.includes(fakturaAttest.STATUS)
    );
  };
  const beslutsAttestanter =
    mergeSort<FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All>(
      fakturaDelContext.beslutsAttestanterAllaFakturadelar?.filter(
        filterSelectableBeslutsattester
      ),
      sortFakturattestByAttestant
    );

  const baskontoKodstrangDel = useMemo(
    () => kodstrangDelar[0],
    [kodstrangDelar]
  );

  const tillaggsinfo = useMemo(
    () =>
      baskontoKodstrangDel
        ? konteringContext.konteringUtils.getKontodelTillaggsinfo(
            fakturaDelContext.kodplanId,
            baskontoKodstrangDel.id
          )
        : null,
    [
      baskontoKodstrangDel,
      fakturaDelContext.kodplanId,
      konteringContext.konteringUtils,
    ]
  );

  const antalsredovisning = useMemo(
    () =>
      baskontoKodstrangDel
        ? konteringContext.konteringUtils.getKontodelAntalRed(
            fakturaDelContext.kodplanId,
            baskontoKodstrangDel.id
          )
        : null,
    [
      baskontoKodstrangDel,
      fakturaDelContext.kodplanId,
      konteringContext.konteringUtils,
    ]
  );

  const tillaggsinfoKomponent: boolean = tillaggsinfo
    ? tillaggsinfoIsKomponent(tillaggsinfo)
    : false;

  const isForbrukning: boolean = tillaggsinfo
    ? isForbrukningsInventarie(tillaggsinfo)
    : false;

  const originKonteringsforslag = fakturaDelContext.getOriginKonteringsforslag(
    props.konteringsforslag?.id ?? ''
  );

  const validations: IFieldValidation[] = useMemo(
    () => formContext?.formState.validation.filter(isFieldError) ?? [],
    [formContext?.formState.validation, isFieldError]
  );

  const validationErrorsForKF = useMemo(
    () =>
      validations?.filter(
        v =>
          v.fieldName.includes(props.konteringsforslag?.id ?? 'noID') ||
          v.path?.includes(props.konteringsforslag?.id ?? 'noID')
      ),
    [validations, props.konteringsforslag?.id]
  );

  const isBeslutsattestantOrReserv =
    beslutsAttestant?._Associations?.Attestratt?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE.toLocaleLowerCase() ===
      loginStateContext.sign.toLocaleLowerCase() ||
    (fakturaDelContext.minFakturaAttest.isReserv &&
      fakturaDelContext.minFakturaAttest.aktuellFakturaAttest?._Associations?.Attestratt?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE.toLocaleLowerCase() ===
        beslutsAttestant?._Associations?.Attestratt?._Associations?.Attestant?._Associations?.Anvandare?.SIGNATURE.toLocaleLowerCase());

  const registerInventarium =
    (props.konteringsforslag?.FI_REGISTRERAS ??
      TEDLRKonteringsForslagFI_REGISTRERASEnum.EJ_ANGIVET) ===
    TEDLRKonteringsForslagFI_REGISTRERASEnum.JA;

  const showInventariumFields =
    registerInventarium && isForbrukning && props.isFIActive;

  const showTillaggsInfo =
    showInventariumFields || (tillaggsinfo && !isForbrukning);

  const statusIcon: JSX.Element | undefined = getStatusIcon(
    validationErrorsForKF ?? []
  );

  const baskonto = konteringContext.konteringUtils.getKontodelByKontodelID(
    fakturaDelContext.kodplanId,
    1,
    baskontoKodstrangDel?.id ?? '',
    fakturaDelContext.bokfDatum
  );

  const getKoddelWarningMessage = useCallback(
    (
      error: IFieldValidation | undefined,
      kontodelDef: IKontodelDef,
      index: number
    ) => {
      if (showTillaggsInfo && index === 0) {
        return `Detta är ${
          isForbrukning ?? false
            ? 'en förbrukningsinventarie'
            : 'ett investeringskonto'
        }, fyll i tilläggsinformation`;
      } else if (kontodelDef.anvandsForMoms) {
        const selectedKoddel = kodstrangDelar[kontodelDef.ordningsNr - 1];
        if (
          selectedKoddel &&
          konteringContext.konteringUtils.isNewSelectedKontodelMomspliktig(
            fakturaDelContext.kodplanId,
            kontodelDef.ordningsNr,
            selectedKoddel.id,
            fakturaDelContext.bokfDatum
          )
        ) {
          return `${kontodelDef.namn} är momspliktig`;
        }
      } else if (error?.type === 'Warning') {
        return error?.message;
      }
      return undefined;
    },
    [
      fakturaDelContext.bokfDatum,
      fakturaDelContext.kodplanId,
      isForbrukning,
      kodstrangDelar,
      konteringContext.konteringUtils,
      showTillaggsInfo,
    ]
  );

  const getRubrikBeloppComp = useMemo(() => {
    switch (radtyp) {
      case 0:
      case null:
      case 2:
        return (
          <EditableAttribute
            key="belopp"
            attribute={beloppAttribute}
            autoFocus={props.autoFocusBelopp}
            collection={fakturaDelCollection.collection}
            value={belopp?.toString() ?? ''}
            label="Belopp"
            editMode={true}
            disabled={!formContext?.formState.editMode || disabled}
            disableRelativeSize
            onChange={onBeloppChange(props.konteringsforslag, props.isNew)}
            onFocus={event => {
              fakturaDelContext.setActiveKF(props.id ?? '');
              const inputField = event.target as HTMLInputElement;
              if (inputField.value.length > 0) {
                if (props.autoFocusBelopp) {
                  inputField.setSelectionRange(0, inputField.value.length);
                }
              }
            }}
            onBlur={() => fakturaDelContext.setActiveKF('')}
            marker={isBeloppChanged}
            size="ownblock"
            fullWidth
            required
            helperText={
              showTillaggsInfo
                ? `Angivet belopp blir ${
                    tillaggsinfoKomponent
                      ? 'komponentens'
                      : isForbrukning
                      ? 'förbrukningsinventariets'
                      : 'investeringens'
                  } anskaffningsvärde`
                : undefined
            }
            errorMessage={getBeloppErrors(
              props.konteringsforslag?.id,
              validationErrorsForKF,
              'Error'
            )}
            warningMessage={getBeloppErrors(
              props.konteringsforslag?.id,
              validationErrorsForKF,
              'Warning'
            )}
            testId={`kontering-${props.konteringsForslagIndex}-Belopp`}
          />
        );

      case 1:
      case 5:
      case 6:
        return (
          <EditableAttribute
            key="BELOPP_EXKL_MOMS"
            attribute={beloppAttribute}
            collection={fakturaDelCollection.collection}
            value={props.konteringsforslag?.BELOPP_EXKL_MOMS}
            label="Belopp exkl moms"
            editMode={true}
            disabled={!formContext?.formState.editMode || disabled}
            disableRelativeSize
            onChange={onBeloppExklMomsChange(
              props.konteringsforslag,
              props.isNew
            )}
            onFocus={event => {
              fakturaDelContext.setActiveKF(props.id ?? '');
              const inputField = event.target as HTMLInputElement;
              if (inputField.value.length > 0) {
                if (props.autoFocusBelopp) {
                  inputField.setSelectionRange(0, inputField.value.length);
                }
              }
            }}
            onBlur={() => fakturaDelContext.setActiveKF('')}
            marker={isBeloppChanged}
            size="ownblock"
            fullWidth
            required
            helperText={
              showTillaggsInfo
                ? `Angivet belopp blir ${
                    tillaggsinfoKomponent
                      ? 'komponentens'
                      : isForbrukning
                      ? 'förbrukningsinventariets'
                      : 'investeringens'
                  } anskaffningsvärde`
                : undefined
            }
            errorMessage={getBeloppErrors(
              props.konteringsforslag?.id,
              validationErrorsForKF,
              'Error'
            )}
            warningMessage={getBeloppErrors(
              props.konteringsforslag?.id,
              validationErrorsForKF,
              'Warning'
            )}
            testId={`kontering-${props.konteringsForslagIndex}-Belopp-exkl-moms`}
          />
        );
      case 3:
      case 4:
        return (
          <EditableAttribute
            key="BELOPP_INKL_MOMS "
            attribute={beloppAttribute}
            collection={fakturaDelCollection.collection}
            value={props.konteringsforslag?.BELOPP_INKL_MOMS}
            label="Belopp inkl moms"
            editMode={true}
            disabled={!formContext?.formState.editMode || disabled}
            disableRelativeSize
            onChange={onBeloppInklMomsChange(
              props.konteringsforslag,
              props.isNew
            )}
            onFocus={event => {
              fakturaDelContext.setActiveKF(props.id ?? '');
              const inputField = event.target as HTMLInputElement;
              if (inputField.value.length > 0) {
                if (props.autoFocusBelopp) {
                  inputField.setSelectionRange(0, inputField.value.length);
                }
              }
            }}
            onBlur={() => fakturaDelContext.setActiveKF('')}
            marker={isBeloppChanged}
            size="ownblock"
            fullWidth
            required
            helperText={
              showTillaggsInfo
                ? `Angivet belopp blir ${
                    tillaggsinfoKomponent
                      ? 'komponentens'
                      : isForbrukning
                      ? 'förbrukningsinventariets'
                      : 'investeringens'
                  } anskaffningsvärde`
                : undefined
            }
            errorMessage={getBeloppErrors(
              props.konteringsforslag?.id,
              validationErrorsForKF,
              'Error'
            )}
            warningMessage={getBeloppErrors(
              props.konteringsforslag?.id,
              validationErrorsForKF,
              'Warning'
            )}
            testId={`kontering-${props.konteringsForslagIndex}-Belopp`}
          />
        );

      default:
        return <EDTypography>Felaktig radtyp</EDTypography>;
    }
  }, [
    belopp,
    beloppAttribute,
    disabled,
    fakturaDelCollection.collection,
    fakturaDelContext,
    formContext?.formState.editMode,
    isBeloppChanged,
    isForbrukning,
    onBeloppChange,
    onBeloppExklMomsChange,
    onBeloppInklMomsChange,
    props.autoFocusBelopp,
    props.id,
    props.isNew,
    props.konteringsForslagIndex,
    props.konteringsforslag,
    radtyp,
    showTillaggsInfo,
    tillaggsinfoKomponent,
    validationErrorsForKF,
  ]);

  const getUtokadBeloppsrad = useCallback(
    (avdragsRatt: number) => {
      switch (radtyp) {
        case 0:
        case null:
        case 2:
        case 1:
        case 3:
          return <></>;

        case 4:
          return (
            <EDBox
              sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                flexWrap: 'wrap',
                height: '100%',
              }}
            >
              <EDBox
                sx={{
                  display: 'flex',
                  justifyContent:
                    isMediumOrLarger && !disabled ? 'normal' : 'space-between',
                  flexFlow: 'row',
                  flexWrap: 'wrap',
                  width: isMediumOrLarger && !disabled ? 'auto' : '100%',
                }}
              >
                <ObjektLank<FakturaDelType__Associations_Faktura__Associations_Konteringsforslag_All__Associations>
                  associationName="IngMoms"
                  collection={konteringsForslagsModel}
                  editMode={!disabled}
                  disableAssociationLink
                  id={props.konteringsforslag?._Associations?.IngMoms?.id}
                  size={!isMediumOrLarger || disabled ? 'small' : 'medium'}
                  fullWidth={!isMediumOrLarger && !disabled}
                  afterAssociationSelected={onMomsSatsSelected}
                  value={
                    props.konteringsforslag?.INGEN_MOMS
                      ? 'Ingen moms'
                      : props.konteringsforslag?._Associations?.IngMoms?.id
                  }
                  validValues={{
                    dataDependencies: [
                      'MOMS_SATS1',
                      'MOMS_SATS2',
                      'DATUMMOMSBYTE',
                    ],
                    validValuesFunction: defaultValues => {
                      return [...defaultValues, noSvenskMomsValue];
                    },
                  }}
                  testId={`kontering-${props.konteringsForslagIndex}-IngMoms`}
                />
                {avdragsRatt && avdragsRatt != 1 && (
                  <EDBox
                    sx={{
                      padding: isMediumOrLarger
                        ? '9px 8px 0 8px'
                        : '9px 8px 0 0px',
                      order: isMediumOrLarger ? 0 : 2,
                      flexGrow: isMediumOrLarger ? 0 : 2,
                    }}
                    testID={`kontering-${props.konteringsForslagIndex}-avdragsRatt`}
                  >
                    <EDCaptionedValue
                      label="Avdrag %"
                      name="Avdrag"
                      valueOnNewRow={false}
                      bold={false}
                      size="large"
                      flexboxCenterChildren={isMediumOrLarger}
                    >
                      <DisplayText
                        value={avdragsRatt * 100}
                        displayer={findFormatter('').displayer}
                        noValueChar="-"
                      />
                    </EDCaptionedValue>
                  </EDBox>
                )}
              </EDBox>
              <EDBox
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  flexGrow: isMediumOrLarger ? 1 : null,
                  height: '100%',
                  paddingLeft: isMediumOrLarger ? '8px' : null,
                  width: isMediumOrLarger ? null : '100%',
                }}
              >
                <EDBox
                  sx={{
                    padding: isMediumOrLarger
                      ? '9px 8px 0 0px'
                      : '0px 8px 0 0px',
                    order: isMediumOrLarger ? 0 : 1,
                  }}
                  testID={`kontering-${props.konteringsForslagIndex}-ingMomsBelopp`}
                >
                  <EDCaptionedValue
                    label="Ingående moms"
                    name="Ingående moms"
                    valueOnNewRow={false}
                    bold={false}
                    size="large"
                    flexboxCenterChildren={isMediumOrLarger}
                  >
                    <DisplayText
                      value={props.konteringsforslag?.ING_MOMS_BELOPP ?? 0}
                      displayer={currencyFormatter.displayer}
                      params={'Decimals="2"'}
                      noValueChar="-"
                    />
                  </EDCaptionedValue>
                </EDBox>
                <EDBox
                  sx={{
                    padding: isMediumOrLarger
                      ? '9px 8px 0 8px'
                      : '0px 8px 0 0px',
                    marginLeft: 'auto',
                    order: isMediumOrLarger ? 0 : 3,
                  }}
                  testID={`kontering-${props.konteringsForslagIndex}-kostnadbelopp-detail`}
                >
                  <EDCaptionedValue
                    label="Kostnad"
                    name="Kostnad"
                    valueOnNewRow={false}
                    bold={false}
                    size="large"
                    flexboxCenterChildren={isMediumOrLarger}
                  >
                    <DisplayText
                      value={belopp}
                      displayer={currencyFormatter.displayer}
                      params={'Decimals="2"'}
                      noValueChar="-"
                    />
                  </EDCaptionedValue>
                </EDBox>
              </EDBox>
            </EDBox>
          );
        case 5:
        case 6:
          return (
            <EDBox
              sx={{
                display: 'flex',
                width: '100%',
                alignItems: 'center',
                flexWrap: 'wrap',
                height: '100%',
              }}
            >
              <ObjektLank<FakturaDelType__Associations_Faktura__Associations_Konteringsforslag_All__Associations>
                associationName="UtlandsMomsMall"
                collection={konteringsForslagsModel}
                editMode={!disabled}
                disableAssociationLink
                id={''}
                size={isMediumOrLarger ? 'large' : 'ownblock'}
                fullWidth={!isMediumOrLarger}
                afterAssociationSelected={onUtlandsMomsSelected}
                validValues={{
                  dataDependencies: ['_typ, UTL_MOMS_SATS', 'AKTIV'],
                  validValuesFunction: defaultValues =>
                    filterUtlandsMomsMall(defaultValues),
                }}
              />
              <EDBox
                sx={{
                  padding: isMediumOrLarger
                    ? '9px 8px 0px 8px'
                    : '0px 8px 0 0px',
                  order: isMediumOrLarger ? 0 : 1,
                }}
                testID={`kontering-${props.konteringsForslagIndex}-utlandskMomsBelopp`}
              >
                <EDCaptionedValue
                  label="Utländsk moms"
                  name="Utländsk moms"
                  valueOnNewRow={false}
                  bold={false}
                  size="large"
                  flexboxCenterChildren={isMediumOrLarger}
                >
                  <DisplayText
                    value={props.konteringsforslag?.UTL_MOMS ?? 0}
                    displayer={currencyFormatter.displayer}
                    params={'Decimals="2"'}
                    noValueChar="-"
                    testId={`kontering-${props.konteringsForslagIndex}-utlandskMomsBelopp-value`}
                  />
                </EDCaptionedValue>
              </EDBox>

              {avdragsRatt !== 0 && (
                <EDBox
                  sx={{
                    padding: isMediumOrLarger
                      ? '9px 8px 0 8px'
                      : '9px 8px 0 0px',
                    order: isMediumOrLarger ? 0 : 2,
                    flexGrow: isMediumOrLarger ? 0 : 2,
                  }}
                  testID={`kontering-${props.konteringsForslagIndex}-avdragsRatt`}
                >
                  <EDCaptionedValue
                    label={`Avdrag (${avdragsRatt * 100} %)`}
                    name="Avdrag"
                    valueOnNewRow={false}
                    bold={false}
                    size="large"
                    flexboxCenterChildren={isMediumOrLarger}
                  >
                    <DisplayText
                      value={props.konteringsforslag?.UTL_MOMS_AVDRAG}
                      displayer={currencyFormatter.displayer}
                      noValueChar="-"
                      testId={`kontering-${props.konteringsForslagIndex}-avdragsRatt-value`}
                    />
                  </EDCaptionedValue>
                </EDBox>
              )}
              <EDBox
                sx={{
                  padding: isMediumOrLarger ? '9px 8px 0 8px' : '0px 8px 0 0px',
                  marginLeft: 'auto',
                  order: isMediumOrLarger ? 0 : 3,
                }}
                testID={`kontering-${props.konteringsForslagIndex}-kostnadbelopp-detail`}
              >
                <EDCaptionedValue
                  label="Kostnad"
                  name="Kostnad"
                  valueOnNewRow={false}
                  bold={false}
                  size="large"
                  flexboxCenterChildren={isMediumOrLarger}
                >
                  <DisplayText
                    value={getUtlandskKostnad(
                      props.konteringsforslag?.BELOPP_EXKL_MOMS,
                      props.konteringsforslag?.UTL_MOMS_SATS,
                      avdragsRatt
                    )}
                    displayer={currencyFormatter.displayer}
                    params={'Decimals="2"'}
                    noValueChar="-"
                    testId={`kontering-${props.konteringsForslagIndex}-kostnadbelopp-detail-value`}
                  />
                </EDCaptionedValue>
              </EDBox>
            </EDBox>
          );

        default:
          return <></>;
      }
    },
    [
      belopp,
      disabled,
      isMediumOrLarger,
      onMomsSatsSelected,
      onUtlandsMomsSelected,
      props.konteringsForslagIndex,
      props.konteringsforslag?.BELOPP_EXKL_MOMS,
      props.konteringsforslag?.INGEN_MOMS,
      props.konteringsforslag?.ING_MOMS_BELOPP,
      props.konteringsforslag?.UTL_MOMS,
      props.konteringsforslag?.UTL_MOMS_AVDRAG,
      props.konteringsforslag?.UTL_MOMS_SATS,
      props.konteringsforslag?._Associations?.IngMoms?.id,
      radtyp,
    ]
  );

  const periodiseraDisabledReason = useMemo(
    () =>
      getPeriodiseraDisabledReason(
        baskonto?.redovisningsTyp,
        periodiseringBeloppEnhet,
        formContext?.formState.currentValues.FakturaBelopp2,
        baskonto?.undantagPeriodisering
      ),
    [
      baskonto?.redovisningsTyp,
      baskonto?.undantagPeriodisering,
      formContext?.formState.currentValues.FakturaBelopp2,
      periodiseringBeloppEnhet,
    ]
  );

  const menuItems: IMenuItem[] = [
    {
      id: 'konteringsForslag',
      icon: 'konteringforslag_menu',
      text: 'Konteringsförslag',
      testId: 'hamta-fran-historiken',
      onClick: () => {
        setSelectedOption(true);
      },
    },
    {
      id: 'fakturaattestImportKontering',
      icon: 'importFromFile',
      text: 'Importera från Excel',
      testId: 'hamta-fran-excel',
      onClick: () => {
        setImportDialogOpen(true);
      },
    },
    {
      id: 'period',
      disabled: !props.konteringsforslag?.PERIODISERAD
        ? periodiseraDisabledReason != undefined
        : false,
      disabledReason: !props.konteringsforslag?.PERIODISERAD
        ? periodiseraDisabledReason
        : undefined,
      icon: 'access_time',
      text: props.konteringsforslag?.PERIODISERAD
        ? 'Ta bort periodisering'
        : 'Periodisera',
      onClick: onPeriodClick,
      testId: 'periodisera',
    },
    {
      id: 'remove',
      icon: 'delete',
      text: 'Ta bort konteringsförslag',
      testId: 'ta-bort-konteringsforslag',
      onClick: onDeleteClick,
    },
  ];

  if (!antalsredovisning?.usesAntal && props.konteringsforslag?.ANTAL != null) {
    onAntalChange(null);
  }

  return (
    <BusinessDataForm
      model={konteringsForslagsModel}
      association="Faktura.Konteringsforslag"
      associatedId={props.id}
    >
      <EDInputGroup>
        <EDBox
          id={props.id}
          sx={theme => ({
            display: 'flex',
            flexFlow: 'row nowrap',
            alignItems: 'center',
            borderBottom: `1px solid ${theme.palette.divider}`,
            borderRadius: 0,
            padding: 0,
            position: 'relative',
            boxSizing: 'border-box',
            [theme.breakpoints.up('sm')]: {
              width: '100%',
            },
            '&:first-of-type': !props.virtual && {
              paddingTop: theme.spacing(1),
            },
            '&:last-child, :only-child': !props.virtual && {
              borderBottom: 0,
            },
          })}
        >
          <EDBox className={classes.expandableInnerContainer}>
            <Accordion
              key="kontering"
              expanded={props.expanded}
              onChange={props.setExpanded}
              onMouseEnter={() => {
                setHovered(true);
              }}
              onMouseLeave={() => {
                setHovered(false);
              }}
              label={
                <>
                  <KonteringLabel
                    kodstrang={kodstrang}
                    belopp={belopp}
                    beloppExklMoms={props.konteringsforslag?.BELOPP_EXKL_MOMS}
                    beloppInklMoms={props.konteringsforslag?.BELOPP_INKL_MOMS}
                    kodstrangBenamningar={kodstrangBenamningar}
                    konteringsforslagSaknas={saknarKontering}
                    attestTyp={attestTyp}
                    infoMissingMessage={
                      saknarKontering ? 'Kontering saknas' : null
                    }
                    isBeslutsattestantOrReserv={isBeslutsattestantOrReserv}
                    onBeslutsattestantChanged={onBeslutsattestantChanged}
                    beslutsAttestant={beslutsAttestant}
                    beslutsattestanter={beslutsAttestanter}
                    periodiseringTomDatum={
                      props.konteringsforslag?.PER_TOM_DATUM
                    }
                    periodiseringFromDatum={
                      props.konteringsforslag?.PER_FROM_DATUM
                    }
                    showPeriodIcon={
                      props.konteringsforslag?.PERIODISERAD ?? false
                    }
                    showTillaggsInfo={showTillaggsInfo ?? false}
                    statusIcon={statusIcon}
                    validationErrors={uniq(validationErrorsForKF ?? [])}
                    radtyp={radtyp}
                    konteringsForslagIndex={props.konteringsForslagIndex}
                  />
                  <span
                    className={cx([
                      classes.functionMenu,
                      isTouch || props.expanded || hovered
                        ? classes.showFunctionMenu
                        : '',
                    ])}
                  >
                    <FunctionMenu
                      id={`konteringkort-${props.konteringsForslagIndex}-show-more`}
                      testId={`konteringkort-${props.konteringsForslagIndex}-show-more`}
                      disabled={disabled}
                    >
                      {menuItems.map((funktionsMenyItem): any => {
                        return (
                          <FunctionItem
                            key={`${funktionsMenyItem.id}-container`}
                            iconType={funktionsMenyItem.icon}
                            onClick={funktionsMenyItem.onClick}
                            disabled={funktionsMenyItem.disabled}
                            disabledReason={funktionsMenyItem.disabledReason}
                            listItemIcon
                            testId={funktionsMenyItem.testId}
                          >
                            {funktionsMenyItem.text}
                          </FunctionItem>
                        );
                      })}
                    </FunctionMenu>
                  </span>
                </>
              }
              classes={{
                ['root']: classes.expansionPanelRoot,
                ['detailsRoot']: classes.content,
                ['expandIconWrapper']: classes.iconWrapper,
                content: classes.summaryContent,
                summaryRoot: classes.summaryRoot,
              }}
              testId={`konteringkort-${props.konteringsForslagIndex}`}
            >
              {showTillaggsInfo && (
                <EDTabs
                  value={currentTabIndex}
                  onChange={setCurrentTabIndex}
                  subtleTabs
                  className={classes.tabs}
                >
                  <EDTab
                    label="Kontering"
                    subtleTab
                    onClick={() =>
                      fakturaDelContext.setActiveKF(props.id ?? '')
                    }
                  />
                  <EDTab
                    label="Tilläggsinformation"
                    subtleTab
                    required
                    onClick={() =>
                      fakturaDelContext.setActiveKF(props.id ?? '')
                    }
                  />
                </EDTabs>
              )}
              {(currentTabIndex === 0 || !showTillaggsInfo) && (
                <EDInputGroup>
                  <EDBox className={classes.sameRowFlex}>
                    <EDBox className={classes.beloppFlex}>
                      {getRubrikBeloppComp}
                    </EDBox>
                    <EDBox className={classes.attestantFlex}>
                      <EDAutoCompleteEdit<FakturaDelQuery_node_TEDLRFakturaDel__Associations_Fakturaattest_All>
                        disabled={disabled}
                        fullWidth
                        getOptionLabel={option => {
                          if (fakturaDelContext.innehallerFleraFakturadelar) {
                            const fakturadel =
                              fakturaDelContext.getFakturadel(option);

                            return (
                              option.Attestant +
                              ` (del ${fakturadel?.ORDNINGS_NR})`
                            );
                          }

                          return option.Attestant ?? '';
                        }}
                        getOptionSelected={option =>
                          option.id === beslutsAttestant?.id
                        }
                        label="Beslutsattesteras av"
                        marker={isBeslutsattestantChanged}
                        onChange={onBeslutsattestantChanged}
                        onClick={event => {
                          event.stopPropagation();
                        }}
                        options={beslutsAttestanter}
                        value={beslutsAttestant}
                        errorMessage={getCertiferValidation(
                          props.konteringsforslag?.id,
                          validationErrorsForKF,
                          'Error'
                        )}
                        warningMessage={getCertiferValidation(
                          props.konteringsforslag?.id,
                          validationErrorsForKF,
                          'Warning'
                        )}
                        testId={`kontering-${props.konteringsForslagIndex}-Attestant`}
                      />
                    </EDBox>
                  </EDBox>

                  {props.konteringsforslag?.PERIODISERAD && (
                    <EDBox className={classes.sameRowFlex}>
                      <EDBox
                        sx={theme => ({
                          marginRight: 0.5,
                          flexGrow: 1,
                          flexShrink: 1,
                          flexBasis: '100px',
                          [theme.breakpoints.down('md')]: {
                            flexBasis: 'auto',
                            flexGrow: 1,
                            paddingRight: theme.spacing(1),
                            width: '100%',
                            marginRight: 0,
                          },
                        })}
                      >
                        <EditableAttribute
                          key="perFromDate"
                          attribute={perFromDateAttribute}
                          collection={fakturaDelCollection.collection}
                          label="Period fr o m"
                          editMode={true}
                          disabled={
                            !formContext?.formState.editMode || disabled
                          }
                          disableRelativeSize
                          onBlur={() => {
                            if (
                              props.konteringsforslag?.PER_FROM_DATUM != null &&
                              props.konteringsforslag?.PER_FROM_DATUM != '' &&
                              (props.konteringsforslag?.PER_TOM_DATUM == null ||
                                props.konteringsforslag?.PER_TOM_DATUM == '')
                            ) {
                              const lastDayinMonth = lastDayInMonth(
                                new Date(
                                  props.konteringsforslag?.PER_FROM_DATUM
                                )
                              );
                              formContextUpdate?.([
                                'Faktura',
                                {
                                  associationName: 'Konteringsforslag',
                                  operation:
                                    props.isNew ?? false
                                      ? 'Add_Values'
                                      : 'Update_Values',
                                  id: props.konteringsforslag?.id ?? '',
                                  values: {
                                    PER_TOM_DATUM: lastDayinMonth
                                      .toLocaleDateString('se-SV')
                                      .toString(),
                                  },
                                },
                              ]);
                            }

                            fakturaDelContext.setActiveKF('');
                            formContext?.formStateDispatch({
                              type: 'TOUCH',
                              path: [
                                'Faktura',
                                'Konteringsforslag',
                                props.konteringsforslag?.id ?? '',
                                'PER_FROM_DATUM',
                              ],
                            });
                          }}
                          onChange={newValue => {
                            const updateValues = {
                              PER_FROM_DATUM: newValue,
                            };

                            formContextUpdate?.([
                              'Faktura',
                              {
                                associationName: 'Konteringsforslag',
                                operation:
                                  props.isNew ?? false
                                    ? 'Add_Values'
                                    : 'Update_Values',
                                id: props.konteringsforslag?.id ?? '',
                                values: updateValues,
                              },
                            ]);
                          }}
                          onFocus={() => {
                            fakturaDelContext.setActiveKF(props.id ?? '');
                          }}
                          marker={
                            formContext?.data._Associations?.Faktura
                              ?._Associations?.Konteringsforslag_All?.[
                              props.konteringsForslagIndex
                            ]?.PER_FROM_DATUM !=
                            props.konteringsforslag?.PER_FROM_DATUM
                          }
                          size="ownblock"
                          fullWidth
                          required
                          errorMessage={
                            validationErrorsForKF.filter(v => {
                              return (
                                v.fieldName === 'PER_FROM_DATUM' &&
                                v.type === 'Error'
                              );
                            })?.[0]?.message
                          }
                          warningMessage={
                            validationErrorsForKF.filter(v => {
                              return (
                                v.fieldName === 'PER_FROM_DATUM' &&
                                v.type === 'Warning'
                              );
                            })?.[0]?.message
                          }
                          value={props.konteringsforslag.PER_FROM_DATUM ?? ''}
                          testId={`kontering-${props.konteringsForslagIndex}-PER_FROM_DATUM`}
                        />
                      </EDBox>
                      <EDBox
                        sx={theme => ({
                          marginLeft: 0.5,
                          flexGrow: 1,
                          flexShrink: 1,
                          flexBasis: '100px',
                          [theme.breakpoints.down('md')]: {
                            flexBasis: 'auto',
                            flexGrow: 1,
                            paddingRight: theme.spacing(1),
                            width: '100%',
                            marginLeft: 0,
                          },
                        })}
                      >
                        <EditableAttribute
                          key="perToDate"
                          attribute={perToDateAttribute}
                          collection={fakturaDelCollection.collection}
                          label="Period t o m"
                          editMode={true}
                          disabled={
                            !formContext?.formState.editMode || disabled
                          }
                          disableRelativeSize
                          onBlur={() => {
                            fakturaDelContext.setActiveKF('');
                            formContext?.formStateDispatch({
                              type: 'TOUCH',
                              path: [
                                'Faktura',
                                'Konteringsforslag',
                                props.konteringsforslag?.id ?? '',
                                'PER_TOM_DATUM',
                              ],
                            });
                          }}
                          onChange={newValue => {
                            const updateValues = {
                              PER_TOM_DATUM: newValue,
                            };

                            formContextUpdate?.([
                              'Faktura',
                              {
                                associationName: 'Konteringsforslag',
                                operation:
                                  props.isNew ?? false
                                    ? 'Add_Values'
                                    : 'Update_Values',
                                id: props.konteringsforslag?.id ?? '',
                                values: updateValues,
                              },
                            ]);
                          }}
                          onFocus={() => {
                            fakturaDelContext.setActiveKF(props.id ?? '');
                          }}
                          marker={
                            formContext?.data._Associations?.Faktura
                              ?._Associations?.Konteringsforslag_All?.[
                              props.konteringsForslagIndex
                            ]?.PER_TOM_DATUM !=
                            props.konteringsforslag?.PER_TOM_DATUM
                          }
                          size="ownblock"
                          fullWidth
                          required
                          errorMessage={
                            validationErrorsForKF.filter(v => {
                              return (
                                v.fieldName === 'PER_TOM_DATUM' &&
                                v.type === 'Error'
                              );
                            })?.[0]?.message
                          }
                          warningMessage={
                            validationErrorsForKF.filter(v => {
                              return (
                                v.fieldName === 'PER_TOM_DATUM' &&
                                v.type === 'Warning'
                              );
                            })?.[0]?.message
                          }
                          value={props.konteringsforslag.PER_TOM_DATUM ?? ''}
                          testId={`kontering-${props.konteringsForslagIndex}-PER_TOM_DATUM`}
                        />
                      </EDBox>
                    </EDBox>
                  )}

                  {getUtokadBeloppsrad(props.avdragsRatt)}
                  {kontodelsDef.map((kontodel, i) => {
                    const bokfDatum = fakturaDelContext.bokfDatum;

                    const visible =
                      kontodel.visibleFromDate <= bokfDatum &&
                      kontodel.visibleToDate >= bokfDatum;

                    const error = validationErrorsForKF.find(v =>
                      isForKontodel(v, kontodel)
                    );

                    const finnsKombinationsError =
                      visible &&
                      validationErrorsForKF
                        .filter(v => isForKontodel(v, kontodel))
                        .some(
                          item =>
                            item.message?.includes('måste anges för') &&
                            item.type === 'Error'
                        ); //Borde kanske typa felen så man ser om det är ett kombinationsfel? Nu söker vi lite fult på texten...

                    const warningMessage = getKoddelWarningMessage(
                      error,
                      kontodel,
                      i
                    );
                    return (
                      visible && (
                        <>
                          <EDAutoCompleteEdit<{
                            name: string;
                            value: string;
                            id: string;
                          } | null>
                            key={kontodel.id}
                            disabled={disabled}
                            disableOpenOnFocus
                            errorMessage={
                              error?.type === 'Error'
                                ? error?.message
                                : undefined
                            }
                            fullWidth
                            getOptionLabel={option => {
                              return option?.name ?? '';
                            }}
                            getOptionSelected={option =>
                              kodstrangDelar[i]?.id === option?.id ||
                              option?.value === ''
                            }
                            label={kontodel.namn}
                            marker={isKontodelChanged(i + 1)}
                            onChange={(option: INewKontodelValue | null) => {
                              onKontodelChange(
                                props.konteringsforslag,
                                i + 1,
                                fakturaDelContext.kodplanId,
                                isFakturaBeloppLowerThanPeriodiseringBeloppEnhet,
                                props.isNew
                              )(option);
                            }}
                            onBlur={() => fakturaDelContext.setActiveKF('')}
                            onFocus={() =>
                              fakturaDelContext.setActiveKF(props.id ?? '')
                            }
                            options={kontodel.kontodelar.map(kontodel => ({
                              name: `${kontodel.kontodel} - ${kontodel.benamning}`,
                              value: kontodel.kontodel,
                              id: kontodel.id,
                            }))}
                            required={
                              (kontodel.ordningsNr === 1 &&
                                (attestTyp === 'KONTROLLATTEST' ||
                                  attestTyp === 'BESLUTSATTEST')) ||
                              finnsKombinationsError
                            }
                            value={
                              kodstrangDelar[i]?.KONTODEL
                                ? {
                                    name: kodstrangDelar[i]?.KONTODEL
                                      ? `${kodstrangDelar[i]?.KONTODEL} - ${kodstrangDelar[i]?.BENAMNING}`
                                      : '',
                                    value: kodstrangDelar[i]?.KONTODEL ?? '',
                                    id: kodstrangDelar[i]?.id ?? '',
                                  }
                                : null
                            }
                            warningMessage={warningMessage}
                            hintMessage={
                              antalsredovisning?.usesAntal && i === 0
                                ? 'Kontot är markerat för antalsredovisning'
                                : undefined
                            }
                            testId={`kontering-${props.konteringsForslagIndex}-${kontodel.namn}`}
                          />
                          {isForbrukning &&
                            props.isFIActive &&
                            i === 0 &&
                            props.konteringsforslag && (
                              <RadioButtonsFI
                                originKonteringsforslag={
                                  originKonteringsforslag
                                }
                                updatedKonteringsforslag={
                                  props.konteringsforslag
                                }
                                konteringsforslagDisabled={disabled}
                              />
                            )}
                          {antalsredovisning?.usesAntal &&
                            i === 0 &&
                            props.konteringsforslag && (
                              <EDBox sx={{ width: '100%', display: 'flex' }}>
                                <EDBox
                                  sx={theme => ({
                                    [theme.breakpoints.up('md')]: {
                                      width: '25%',
                                    },
                                  })}
                                >
                                  <EditableAttribute
                                    attribute={antalAttribute}
                                    collection={konteringsForslagsModel}
                                    disabled={
                                      !formContext?.formState.editMode ||
                                      disabled
                                    }
                                    disableRelativeSize
                                    editMode={
                                      formContext?.formState.editMode ?? false
                                    }
                                    label={`Ange antal (${antalsredovisning.unit?.ENHET})`}
                                    marker={
                                      formContext?.formState.currentValues
                                        ?._Associations?.Faktura?._Associations
                                        ?.Konteringsforslag_All?.[
                                        props.konteringsForslagIndex
                                      ]?.ANTAL !=
                                      formContext?.data?._Associations?.Faktura
                                        ?._Associations
                                        ?.Konteringsforslag_All?.[
                                        props.konteringsForslagIndex
                                      ]?.ANTAL
                                    }
                                    onChange={onAntalChange}
                                    rightPadding={0}
                                    fullWidth
                                    value={
                                      formContext?.formState.currentValues
                                        ?._Associations?.Faktura?._Associations
                                        ?.Konteringsforslag_All?.[
                                        props.konteringsForslagIndex
                                      ]?.ANTAL
                                    }
                                  />
                                </EDBox>
                              </EDBox>
                            )}
                        </>
                      )
                    );
                  })}
                </EDInputGroup>
              )}
              {currentTabIndex === 1 &&
                showTillaggsInfo &&
                tillaggsinfo &&
                props.konteringsforslag && (
                  <Tillaggsinfo
                    tillaggsinfo={tillaggsinfo}
                    originKonteringsforslag={originKonteringsforslag}
                    updatedKonteringsforslag={props.konteringsforslag}
                    beloppValue={belopp?.toString() ?? ''}
                    fakturaDelCollection={fakturaDelCollection}
                    isBeloppChanged={isBeloppChanged}
                    konteringsforslagDisabled={disabled}
                    onBeloppChange={onBeloppChange(
                      props.konteringsforslag,
                      props.isNew
                    )}
                    isKomponent={tillaggsinfoKomponent}
                    isForbrukning={isForbrukning}
                    kontodelsDef={kontodelsDef}
                    avskrivningKontodelOrdningsnummerList={konteringContext.konteringUtils.getTillaggsinfoAvskrivningKontodelOrdningsnummerList(
                      fakturaDelContext.bokfDatum
                    )}
                    fakturaBokfDatum={fakturaDelContext.bokfDatum}
                  />
                )}
            </Accordion>
          </EDBox>
        </EDBox>
        {(formContext?.formState.editMode || !disabled) && (
          <>
            {selectedOption && (
              <FakturaAttestKonteringHistoryModal
                open={selectedOption}
                setNewBeloppChange={props.setNewBeloppChange}
                setSelectedOption={setSelectedOption}
                supplierID={
                  formContext?.data?._Associations?.Faktura?._Associations
                    ?.Leverantor?.id
                }
                originKonteringforslag={props.konteringsforslag}
              />
            )}
          </>
        )}
        <FakturaattestImportDialog
          importDialogOpen={importDialogOpen}
          setImportDialogOpen={setImportDialogOpen}
          setNewBeloppChange={props.setNewBeloppChange}
          isFIActive={props.isFIActive}
        />
      </EDInputGroup>
    </BusinessDataForm>
  );
};

export default KonteringForslagComp;
